import styled from 'styled-components';

const DEFAULT_BORDER_RADIUS = 'var(--default-normalized-border-radius)';
const INTERMEDIATE_BORDER_RADIUS = '4px';

const createBorderRadius = ({
  topLeft = DEFAULT_BORDER_RADIUS,
  topRight = DEFAULT_BORDER_RADIUS,
  bottomRight = DEFAULT_BORDER_RADIUS,
  bottomLeft = DEFAULT_BORDER_RADIUS,
}) => {
  return [topLeft, topRight, bottomRight, bottomLeft].join(' ');
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${({ total }) => {
    const repeat = Math.max(1, total);

    return `repeat(${repeat}, 1fr)`;
  }};
  gap: 2px;
    
  }
  & > *:not(:first-child):not(:last-child) {
    --normalized-border-radius: ${createBorderRadius({
      topLeft: INTERMEDIATE_BORDER_RADIUS,
      topRight: INTERMEDIATE_BORDER_RADIUS,
      bottomRight: INTERMEDIATE_BORDER_RADIUS,
      bottomLeft: INTERMEDIATE_BORDER_RADIUS,
    })};
  }

  & > *:first-child {
    --normalized-border-radius: ${createBorderRadius({
      topRight: INTERMEDIATE_BORDER_RADIUS,
      bottomRight: INTERMEDIATE_BORDER_RADIUS,
    })};
  }

  & > *:last-child {
    --normalized-border-radius: ${createBorderRadius({
      topLeft: INTERMEDIATE_BORDER_RADIUS,
      bottomLeft: INTERMEDIATE_BORDER_RADIUS,
    })};
  }
`;
